import React, { Dispatch, FC, SetStateAction } from 'react';
import PhoneInput from 'react-phone-input-2';

interface Props {
  value: string;
  setValue?: Dispatch<SetStateAction<string>>;
  hasDisabled?: boolean;
  checkWaValid?: (phone: string) => void;
  validatePrimaryPhone?: () => boolean;
  countryCodeEditable?: boolean;
}

const InputPhoneNative: FC<Props> = ({
  value,
  setValue,
  hasDisabled = false,
  countryCodeEditable = false,
  checkWaValid,
  validatePrimaryPhone,
}) => {
  const handleOnChange = (val: string, country: string) => {
    if (setValue) {
      setValue(val);
    }
  };

  const handleOnBlur = () => {
    if (validatePrimaryPhone) {
      validatePrimaryPhone();
    }
    if (checkWaValid && value) {
      checkWaValid(value);
    }
  };

  return (
    <PhoneInput
      disabled={hasDisabled}
      countryCodeEditable={countryCodeEditable}
      value={value}
      placeholder="62xxxxxxxxx"
      country="id"
      onBlur={handleOnBlur}
      onChange={(value, country: any) => handleOnChange(value, country.dialCode)}
      enableSearch={true}
      inputStyle={{ width: '100%' }}
      dropdownClass="z-index-3"
    />
  );
};

export default InputPhoneNative;
